/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

import { UpdateMemoryCellRequest } from '../models/update-memory-cell.request';
import { MemoryCell } from '../models/memory-cell.entity';

export type MemoryCellUpdatePathVariables = {
	gameId: string;
	gridId: string;
	cellId: string;
};

@Injectable()
export class MemoryCellService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	public update(
		path: MemoryCellUpdatePathVariables,
		body: UpdateMemoryCellRequest,
	): Observable<MemoryCell> {
		return this.http.patch<MemoryCell>(
			`${this.config.apiUrl}/api/v2/private/games/${path.gameId}/phases/memory/grids/${path.gridId}/cells/${path.cellId}`,
			body,
		);
	}
}
